import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBillingPricingQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetBillingPricingQueryPage = { readonly __typename?: 'RootQueryType', readonly billingPricing: { readonly __typename?: 'BillingPricing', readonly partnerDiscount?: { readonly __typename?: 'BillingPartnerDiscount', readonly partnerName: string, readonly percent: number } | null, readonly tariffs: ReadonlyArray<{ readonly __typename?: 'BillingTariff', readonly key: string, readonly name: string, readonly spentMax?: number | null, readonly spentMin?: number | null, readonly maxSubAccounts?: number | null, readonly maxAiReportRuns?: number | null, readonly adAgency: boolean, readonly prices?: ReadonlyArray<{ readonly __typename?: 'BillingTariffPrice', readonly amount?: number | null, readonly discount: number, readonly period: Types.BillingDiscountPeriod, readonly firstPaymentMonthlyAmount?: number | null }> | null }> } };


export const GetBillingPricingDocument = gql`
    query getBillingPricing {
  billingPricing {
    partnerDiscount {
      partnerName
      percent
    }
    tariffs {
      key
      name
      spentMax
      spentMin
      maxSubAccounts
      maxAiReportRuns
      adAgency
      prices {
        amount
        discount
        period
        firstPaymentMonthlyAmount
      }
    }
  }
}
    `;

/**
 * __useGetBillingPricingQuery__
 *
 * To run a query within a React component, call `useGetBillingPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingPricingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBillingPricingQuery(baseOptions?: Apollo.QueryHookOptions<GetBillingPricingQueryPage, GetBillingPricingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillingPricingQueryPage, GetBillingPricingQueryVariables>(GetBillingPricingDocument, options);
      }
export function useGetBillingPricingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillingPricingQueryPage, GetBillingPricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillingPricingQueryPage, GetBillingPricingQueryVariables>(GetBillingPricingDocument, options);
        }
export function useGetBillingPricingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBillingPricingQueryPage, GetBillingPricingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBillingPricingQueryPage, GetBillingPricingQueryVariables>(GetBillingPricingDocument, options);
        }
export type GetBillingPricingQueryHookResult = ReturnType<typeof useGetBillingPricingQuery>;
export type GetBillingPricingLazyQueryHookResult = ReturnType<typeof useGetBillingPricingLazyQuery>;
export type GetBillingPricingSuspenseQueryHookResult = ReturnType<typeof useGetBillingPricingSuspenseQuery>;
export type GetBillingPricingQueryResult = Apollo.QueryResult<GetBillingPricingQueryPage, GetBillingPricingQueryVariables>;